/* eslint new-cap: ['error', { 'capIsNew': false }], no-param-reassign:0 */
import React from 'react';
import { connect } from 'react-redux';
import { dateTimePickerFormat } from '../../../../../util/util.jsx';
import {
  Button,
  Col,
  Row,
} from 'react-bootstrap';
import {
  FormControl,
  Checkbox,
  DateTimePicker2 as DateTimePicker,
} from '../../../../form/FormControls.jsx';
import Label from '@/component/form/Label.jsx';
import CurrencyInput from '@/component/form/currencyinput/index.jsx';
import RefPicker from '../../../../dict/simple/select/DictPicker.jsx';
import UserPicker from '@/component/managment/users/Select.jsx';
import FancyInput from '@/component/form/numinput/index.jsx';
import PortContainerList from './PortContainerList';
import ProductsViewer from '../ProductsViewer.jsx';
import { addNewPort } from '../../store/ports.store.js';
import { handleFormChanged } from '@/store/allaround.store.js';
import { updateDealField, updateDealFields } from '../../store/deal.store';
import { getSimpleListWrapper } from '@/component/dict/simple/SimpleWrapper';
import { List } from 'immutable';
import { REF_NAME as LOADING_TERM_REF_NAME, REF_PATH as LOADING_TERM_REF_PATH }
  from '../../../../dict/simple/loadingterm/Const';

import momentLocalizer from 'react-widgets-moment';
import moment from 'moment';
import RequiredFormControl from '../../../../form/RequiredFormControl.jsx';
import { creationTimeTooltip } from '@/util/util';
moment.locale('en');
momentLocalizer();
import { usdDefaultCurrencyRates } from '@/util/util.jsx';
import AbstractTransportEdit from '../AbstractTransportEdit';
import TransportElement from '../../elements/TransportElement.jsx';
import { Currency } from '@/consts/currency';
import loadport from '@/../style/loadportwhite.png';
import unloadport from '@/../style/unloadportwhite.png';

class BulkVesselEdit extends AbstractTransportEdit {
  constructor(props) {
    super(props);
    this.init = this.init.bind(this);
    this.addLoadingPort = this.addLoadingPort.bind(this);
    this.addDischargePort = this.addDischargePort.bind(this);
    this.state = {
      init: false,
    };
    this.term = null;
  }

  componentWillMount() {
    if (!this.props.loadingTerms || this.props.loadingTerms.size == 0) {
      getSimpleListWrapper(LOADING_TERM_REF_NAME, LOADING_TERM_REF_PATH);
    }
    if (this.props.loadingTerms && this.props.loadingTerms.size > 0) {
      this.init(this.props);
    }
  }

  componentWillReceiveProps(props) {
    if (props.loadingTerms && props.loadingTerms.size > 0) {
      this.init(props);
    }
  }

  addLoadingPort() {
    // так же передаем поля по умолчанию, т.к. форма собирается по onChange
    this.props.addNewPort(
      'vesselLoadingPorts',
      {
        status: 'EMPTY',
        destinationType: 'LOADING',
        dispatchType: 'RATE',
        termModificator: 'UU',
        detentionCurrency: Currency.DOLLAR,
        demurrageCurrency: Currency.DOLLAR,
        dispatchCurrency: Currency.DOLLAR,
        term: this.term,
      }
    );
  }

  addDischargePort() {
    // так же передаем поля по умолчанию, т.к. форма собирается по onChange
    this.props.addNewPort(
      'vesselDischargePorts',
      {
        status: 'EMPTY',
        destinationType: 'DISCHARGE',
        dispatchType: 'RATE',
        termModificator: 'UU',
        detentionCurrency: Currency.DOLLAR,
        demurrageCurrency: Currency.DOLLAR,
        dispatchCurrency: Currency.DOLLAR,
        term: this.term,
      }
    );
  }

  init(props) {
    if (!this.state.init &&
      !props.data.get('id')) {
      const term = props.loadingTerms.find(lt => lt.get('name') == 'SHEX');
      this.term = term ? term.get('id') : null;
      if (!props.data.get('vesselLoadingPorts', new List()).size) {
        this.addLoadingPort();
      }
      if (!props.data.get('vesselDischargePorts', new List()).size) {
        this.addDischargePort();
      }
      this.setState({ init: true });
    }
  }

  render() {
    return (
      <div>
        <input
          name="transportType" defaultValue="BULK" style={{ display: 'none' }}
        />
        <Col xs={12} className={'dealsEditTopPanel'}>
          <Row>
            <Col md={6}>
              <Row>
                <Col md={3}>
                  <Label
                    label="Creator" vertical sm={12}

                  >
                    {creationTimeTooltip(this.props.data, <UserPicker
                      name="creator"
                      defaultValue={this.props.isNew ? this.props.currentUser :
                        this.props.data.get('creator')}
                      disabled
                    />)}
                  </Label>

                </Col>
                <Col md={6}>
                  <Label
                    label="Chartering responsible"
                    vertical
                    sm={12}

                  >
                    <UserPicker
                      name="responsibles" multi
                      defaultValue={this.props.isNew ? this.props.currentUser
                        : this.props.data.get('responsibles')}
                      disabled={this.props.locked || !this.props.allowResponsiblesEdit}
                    />
                  </Label>
                </Col>
                <Col md={3}>
                  <Label
                    label="Charterparty date"
                    vertical
                    sm={12}

                  >
                    <DateTimePicker
                      format={dateTimePickerFormat}
                      time={false}
                      name="charterParty"
                      onChange={(() => this.props.handleFormChanged())}
                      defaultValue={this.props.data.get('charterParty')
                        ? new Date(this.props.data.get('charterParty'))
                        : null}
                      disabled={this.props.disabled}
                    />
                  </Label>
                </Col>
              </Row>
            </Col>
            <Col md={4}>
              <Label label="Product" vertical sm={12} >
                {this.props.data.get('links', new List()).size ?
                  <div>
                    <ProductsViewer links={this.props.data.get('links')} />
                    <input
                      name="product" value={this.props.product}
                      style={{ display: 'none' }}
                      onChange={() => ({})}
                    />
                  </div>
                  :
                  <RequiredFormControl
                    component={RefPicker}
                    noAddButton
                    dict="product"
                    dictType="complex"
                    name="linkedProducts"
                    onChangeFunc={val =>
                      this.props.updateDealField('linkedProducts', val.map(v => v.value))}
                    defaultValue={this.props.data.get('linkedProducts')}
                    multi
                    disabled={this.props.disabled}
                  />
                }
              </Label>
            </Col>
            <Col md={2} className="transport-buttons">
              <Button
                bsSize="xsmall"
                bsStyle={this.props.data.get('isArchived') ? 'primary' : 'gray'}
                id="isArchived"
                disabled={this.props.disabled || !(this.props.data.get('id')
                || this.props.data.get('id') == 0)}
                onClick={this.props.onArchive}
                title="Archive"
              >
                Archive
              </Button>
              <Button
                bsSize="xsmall"
                bsStyle={this.props.data.get('hasDispute') ? 'primary' : 'gray'}
                id="isArchived"
                disabled={this.props.disabled}
                onClick={() => {
                  this.props.updateDealField('hasDispute', !this.props.data.get('hasDispute'));
                  this.props.handleFormChanged();
                }}
                title="Dispute"
              >
                Dispute
              </Button>
            </Col>
          </Row>
          <Row>
            <Col md={2} style={{ paddingRight: 0}}>
              <Label label="Vessel name" vertical sm={12} >
                <FormControl
                  name="vesselName"
                  defaultValue={this.props.data.get('vesselName')}
                  onChange={this.onContractNumberChange}
                  disabled={this.props.disabled}
                />
              </Label>
            </Col>
            <Col md={3}>
              <Label label="Ship broker" vertical sm={12} >
                <RefPicker
                  dict="vesselbroker"
                  name="vesselBroker"
                  defaultValue={this.props.data.get('vesselBroker')}
                  onChangeFunc={v => this.props.updateDealField('vesselBroker', v.value)}
                  disabled={this.props.disabled}
                />
              </Label>
            </Col>
            <Col md={1} style={{ padding: 0 }}>
              <div className={'dachex-checkbox'}>
                <Checkbox
                  name="datex"
                  defaultChecked={this.props.data.get('datex')}
                  onChange={() => this.props.updateDealField('datex',
                    !this.props.data.get('datex'))}
                  disabled={this.props.disabled}
                />
                <span>Dachex</span>
              </div>
            </Col>
            <Col md={2}>
              <Label label="Ship owner" vertical sm={12} >
                <RefPicker
                  dict="owner" name="owner" defaultValue={this.props.data.get('owner')}
                  onChangeFunc={v => this.props.updateDealField('owner', v.value)}
                  disabled={this.props.disabled}
                />
              </Label>
            </Col>
            <Col md={1}>
              <Label label="DWT" vertical sm={12} >
                <FancyInput
                  className="form-control"
                  thousand
                  positive
                  fraction={0}
                  negative={false}
                  type="number"
                  id="dwt" name="dwt"
                  value={this.props.data.get('dwt')}
                  disabled={this.props.disabled}
                  onChange={(e, val) => this.props.updateDealField('dwt', val)}
                />
              </Label>
            </Col>
            <Col md={3}>
              <Label label="Freight" vertical sm={12} >
                <Row id="freightCurrency">
                  <Col sm={3}>
                    <CurrencyInput
                      name="freightCurrency"
                      defaultValue={this.props.data.get('freightCurrency')}
                      defaultValueRates={usdDefaultCurrencyRates(
                        this.props.data.get('freightCurrencyRates'))}
                      onChange={this.onChangeFreightCurrency}
                      disabled={this.props.disabled}
                    />
                  </Col>
                  <Col sm={9}>
                    {this.freightInput()}
                  </Col>
                </Row>
              </Label>
            </Col>
          </Row>
        </Col>
        <Col xs={12}>
          <Row >
            <Col xs={12} className={'transport-edit-total-bl-row'}>
              {this.renderBLInfo()}
            </Col>
            <Col xs={12}>
              <TransportElement data={this.props.data} editForm disabled={this.props.disabled} />
            </Col>
          </Row>

          <Row className={'bulk-vessel-edit-port-block'}>
            <Col md={6} style={{ paddingRight: 5 }}>
              <Col md={12} className={'bulk-vessel-edit-port-element'}>
                <div style={{ padding: '15px 15px 0 15px' }}>
                  <PortContainerList
                    loadingPortType="vesselLoadingPorts"
                    dischargePortType="vesselDischargePorts"
                    portType="vesselLoadingPorts"
                    disabled={this.props.disabled}
                  />
                </div>
              </Col>
              <div className={'add-port-button-container'}>
                {!this.props.disabled ?
                  < Button
                    onClick={this.addLoadingPort}
                    bsStyle="primary"
                    id="addLoadingPort"
                    className={'add-port-button'}
                  >
                    <img src={loadport} role={'presentation'} />
                    Add loading port
                  </Button>
                  : ''
                }
              </div>
            </Col>
            <Col md={6} style={{ paddingLeft: 5 }}>
              <Col md={12} className={'bulk-vessel-edit-port-element'}>
                <div style={{ padding: '15px 15px 0 15px' }}>
                  <PortContainerList
                    loadingPortType="vesselLoadingPorts"
                    dischargePortType="vesselDischargePorts"
                    portType="vesselDischargePorts"
                    disabled={this.props.disabled}
                  />
                </div>
              </Col>
              <div className={'add-port-button-container'}>
                {!this.props.disabled ?
                  <Button
                    onClick={this.addDischargePort}
                    bsStyle="primary"
                    id="addDischargePort"
                    className={'add-port-button'}
                  >
                    <img src={unloadport} role={'presentation'} />
                    Add discharge port
                  </Button>
                  : ''
                }
              </div>
            </Col>
          </Row>

        </Col>
      </div>);
  }
}

BulkVesselEdit.propTypes = {
  data: React.PropTypes.object,
  disabled: React.PropTypes.bool,
  addNewPort: React.PropTypes.func,
  product: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
  updateProduct: React.PropTypes.func,
  loadingTerms: React.PropTypes.object,
  vesselLoadingPorts: React.PropTypes.object,
  vesselDischargePorts: React.PropTypes.object,
  currentUser: React.PropTypes.number,
  updateDealField: React.PropTypes.func,
  updateDealFields: React.PropTypes.func,
  isNew: React.PropTypes.bool,
  onArchive: React.PropTypes.func,
  locked: React.PropTypes.bool,
  allowResponsiblesEdit: React.PropTypes.bool,
};

export default connect((state) => ({
  loadingTerms: state.getIn(['references', 'simple', LOADING_TERM_REF_PATH], List()),
  vesselLoadingPorts: state.getIn(['data', 'deals', 'ports', 'vesselLoadingPorts'], List()),
  vesselDischargePorts: state.getIn(['data', 'deals', 'ports', 'vesselDischargePorts'], List()),
  currentUser: Number(state.getIn(['session', 'id'])),
}),
(dispatch) => ({
  addNewPort(portType, initData) {
    addNewPort(dispatch, portType, initData);
  },
  updateDealField(field, value) {
    updateDealField(dispatch, 'transport', field, value);
  },
  updateDealFields(field, value) {
    updateDealFields(dispatch, field, value);
  },
  handleFormChanged() {
    handleFormChanged(dispatch);
  },
})
)(BulkVesselEdit);
